import { gql } from "@apollo/client";

import { SUBSCRIPTION_FRAGMENT } from "@graphql/fragments";

export const UPDATE_SUBSCRIPTION = gql`
  ${SUBSCRIPTION_FRAGMENT}

  mutation updateSubscription($planOption: PlanOption!) {
    updateSubscription(input: { planOption: $planOption }) {
      ...SubscriptionFragment
    }
  }
`;
